import { axios1 } from '@/api/instance'

/* 精彩活动列表 */
/**
 * 查询精彩活动列表
 * @param {object} data
 */
export const getWonderActList = (params, data) => {
  return axios1.postByJson('/activity/activity/back/find/configure/list', data, { params })
}

/**
 * 新增或者修改的精彩活动信息
 * @param {object} data
 */
export const saveActInfo = (data) => {
  return axios1.postByJson('/activity/activity/back/configure/saveOrUpdate', data)
}

/**
 * 删除精彩活动
 * @param {object} params
 */
export const deleteActInfo = (params) => {
  return axios1.get('/activity/activity/back/configure/delete', { params })
}

/**
 * 置顶接口
 * @param {object} params
 */
export const topActInfo = (params) => {
  return axios1.get('/activity/activity/back/configure/top', { params })
}

/* 天天抽奖 start 抽奖活动管理 */

/**
 * 抽奖活动管理-活动管理列表
 @param {Object} data
 @param {string} data.page -当前页
 @param {string} data.size -分頁數量
 @param {string} data.activtyStatus 0-进行中 1-已结束 2-未开始 ,
 @return {Promise}
 */
export const findList = (params) => {
  return axios1.get('/activity/luckdraw/manage/findList', { params })
  // return axios1.get('/luckdraw/manage/findList', { params })
}

/**
 * 抽奖活动管理-删除
 @param {Array} Array['id']
 @return {Promise}
 */
export const deletesingle = (ids) => {
  return axios1.postByJson(`/activity/luckdraw/manage/delete?ids=${ids}`)
  // return axios1.postByJson(`/luckdraw/manage/delete?ids=${ids}`)
}

/**
 * 抽奖活动管理-编辑
 @param {number} id
 @return {Promise}
 */
export const detailPrize = (id) => {
  const config = {
    params: {
      id
    }
  }
  return axios1.post('/activity/luckdraw/manage/detail', null, config)
}

/**
 * 抽奖活动管理-导出兑换码
 @param {Object} data
 @return {Promise}
 */
// export const exportCKey = (data) => {
//   return axios1.post('/activity/luckdraw/manage/exportCKey', data)
// }

/* 抽奖列表 */

/**
 * 抽奖活动管理-新增页（奖品类型）
 @param {string} type -默认值：DRAW_TYPE
 @return {Promise}
 */
export const getActivityEnum = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/activity/common/getActivityEnum', null, config)
  // return axios1.post('/activity/common/getActivityEnum', data)
}

/**
 * 抽奖列表-新增
 @param {object} data
 @param {number} data.drawNumSetup -抽奖次数周期设置 0-永久 1-每日
 @param {number} data.inviteDrawSet -分享获得的次数抽奖结果 000-随机
 @param {number} data.inviteIsGratis - 分享获得的次数是否免费 0-永久 1-每日
 @param {number} data.mustPrizeSetup - 必中奖品周期设置 0-永久 1-每日
 @return {Promise}
 */
export const saveOrUpdate = (data) => {
  return axios1.postByJson('/activity/luckdraw/set/saveOrUpdate', data)
  // return axios1.postByJson('/luckdraw/set/saveOrUpdate', data)
}

/* 中奖记录 */

/**
 * 中奖记录-查询
 @param {object} data
 @return {Promise}
 */
export const inquireList = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/luckdraw/stream/findReceiveListByCondition', null, config)
  // return axios1.postByJson('/luckdraw/stream/findListByCondition', data)
}

/**
 * 中奖记录-奖品发放
 @param {object} data
 @param {object} data.id  -中奖纪录id
 @param {object} data.status -已领取-0 未领取-1
 @return {Promise}
 */
export const distribution = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/luckdraw/stream/updateStatus', null, config)
  // return axios1.post('/luckdraw/stream/updateStatus', { ...data })
}

/* 提现管理 */

/**
 * 提现管理-获取table列表
 @param {object} data
 @return {Promise}
 */
export const cashmagetList = (params) => {
  return axios1.get('/activity/cashout/manage/findList', { params })
  // return axios1.get('/cashout/manage/findList', { params })
}

/**
 * 提现管理-删除
 @param {object} data
 @param {Array} data.ids - 当前项id
 @return {Promise}
 */
export const cashmadel = (data) => {
  return axios1.postByJson('/activity/cashout/manage/delete', data)
  // return axios1.postByJson('/cashout/manage/delete', data)
}

/**
 * 提现管理-编辑
 @param {object} data
 @param {number} data.id - 当前项id
 @return {Promise}
 */
export const cashmadetail = (id) => {
  const config = {
    params: {
      id
    }
  }
  return axios1.post('/activity/cashout/manage/detail', null, config)
  // return axios1.post('/cashout/manage/detail', { ...id })
}

/**
 * 提现管理-删除
 @param {number} ids - 当前项id
 @return {Promise}
 */
export const cashmadelete = (ids) => {
  const config = {
    params: {
      ...ids
    }
  }
  return axios1.post('/activity/cashout/manage/delete', null, config)
  // return axios1.post('/cashout/manage/delete', { ...ids })
}

/**
 * 提现管理-上下架
 @param {object} data
 @param {number} data.id - 当前项id
 @param {number} data.isopen - 0-上架 1-下架
 @return {Promise}
 */
export const undercarriageEnd = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/cashout/manage/end', null, config)
  // return axios1.post('/cashout/manage/end', { ...data })
}

/**
 * 提现管理-新增
 @param {object} data
 @param {number} data.amount - 金额
 @param {string} data.cashoutName - 提现名称
 @param {number} data.cashoutType - 提现方式 0-支付宝 1-京东E卡
 @param {number} data.id - ID
 @param {string} data.tips - 超出数量提示
 @return {Promise}
 */
export const cashmaAddsave = (data) => {
  return axios1.postByJson('/activity/cashout/manage/saveOrUpdate', data)
  // return axios1.postByJson('/cashout/manage/saveOrUpdate', data)
}

/* 提现审核 */

/**
 * 提现审核-查询列表
 @param {object} data
 @param {number} data.cashoutName - 提现名称
 @param {number} data.cashoutType - 提现方式 0-支付宝 1-京东E卡
 @param {number} data.cashoutendtime - 中间结束时间
 @param {number} data.cashoutstarttime - 提现开始时间
 @param {number} data.chshoutStatus - 提现状态 0-待发放 1-已发放 2-已拒绝
 @param {number} data.page - 页
 @param {number} data.size - 条
 @param {string} data.phone - 超出数量提示
 @return {Promise}
 */
export const withdrafindList = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/cashout/stream/findList', null, config)
  // return axios1.postByJson('/cashout/stream/findList', data)
}

/**
 * 提现审核-修改审核状态
 @param {object} data
 @param {Array} data.ids - 提现审核id
 @param {string} data.chshoutStatus - 提现状态 1-已发放 2-已拒绝
 @return {Promise}
 */

export const withdraoperation = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/cashout/stream/operation', null, config)
  // return axios1.post('/cashout/stream/operation', { ...data })
}

// 抽奖活动海报列表（支持模糊查询）
export const getPosterFindList = params => {
  // return axios1.get('/activity/lottery/Poster/findList', { params })
  return axios1.get('/activity/poster/findList', { params })
}
// 抽奖活动海报列表（支持模糊查询）
export const getFindActivityList = data => {
  const config = {
    params: {
      ...data
    }
  }
  // return axios1.post('/activity/luckdraw/manage/findActivityList', null, config)
  return axios1.get('/activity/total/findActivityTotalList', null, config)
}
// 活动海报新建
export const saveOrUpdatePoster = (data) => {
  return axios1.postByJson('/activity/poster/saveOrUpdate', data)
}
// 活动海报详情
export const getPosterDetail = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/poster/detail', null, config)
}
// 活动海报删除
export const getPosterDelete = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/poster/delete', null, config)
}

/** 天天抽奖 end
 * 提现审核-导出
 @param {object} data
 @param {number} data.cashoutName - 提现名称
 @param {number} data.cashoutType - 提现方式 0-支付宝 1-京东E卡
 @param {number} data.cashoutendtime - 中间结束时间
 @param {number} data.cashoutstarttime - 提现开始时间
 @param {number} data.chshoutStatus - 提现状态 0-待发放 1-已发放 2-已拒绝
 @param {number} data.page - 页
 @param {number} data.size - 条
 @param {string} data.phone - 超出数量提示
 @return {Promise}
 */
export const withdrarexport = (data) => {
  return axios1.postByJson('/cashout/stream/export', data)
}

/** 砍价够 开始 */
// 计算新用户刀术
export const CalculateBargainCount = (data) => {
  const url = '/bargainActivity/bargainActivity/back/configure/commodity/calculateBargainCount'
  return axios1.postByJson(url, data)
}
// 缓存砍价商品活动详情
export const getBargainCache = (params) => {
  const url = 'bargainActivity/bargainActivity/back/configure/clearBargainCommodity'
  return axios1.postByJson(url, {}, { params })
}
// 砍价活动列表
export const getBargainActivityList = (data) => {
  const url = '/bargainActivity/bargainActivity/back/configure/getBargainActivityList'
  return axios1.postByJson(url, data)
}
// 删除砍价活动配置
export const deleteBargainActivity = (params) => {
  const url = '/bargainActivity/bargainActivity/back/configure/deleteBargainActivity'
  return axios1.post(url, {}, { params })
}
// 砍价商品活动列表
export const getBargainCommodityList = (data) => {
  const url = '/bargainActivity/bargainActivity/back/configure/getBargainCommodityList'
  return axios1.postByJson(url, data)
}
// 新建砍价活动信息
export const saveBargainActivity = (data) => {
  const url = '/bargainActivity/bargainActivity/back/configure/saveOrUpdateBargainActivity'
  return axios1.postByJson(url, data)
}
// 查看砍价活动配置详情
export const getBargainConfigure = id => {
  return axios1.get(`/bargainActivity/bargainActivity/back/configure/${id}`)
}
// 查看砍价活动商品的sku
export const getBargainSku = id => {
  return axios1.get(`/bargainActivity/bargainActivity/back/product/sku?uuid=${id}`)
}
// 查看砍价商品配置详情
export const getBargainCommodity = id => {
  return axios1.get(`/bargainActivity/bargainActivity/back/configure/commodity/${id}`)
}
// 新建砍价商品活动信息
export const saveBargainCommodity = (data) => {
  const url = '/bargainActivity/bargainActivity/back/configure/saveOrUpdateBargainCommodity'
  return axios1.postByJson(url, data)
}
// 删除砍价商品活动配置
export const deleteBargainCommodity = (params) => {
  const url = '/bargainActivity/bargainActivity/back/configure/deleteBargainCommodity'
  return axios1.postByJson(url, {}, { params })
}
// 获取电商的商品
export const getBargainGoods = (params) => {
  return axios1.get('/content/product/official/mall/list', { params })
}
// 获取电商商品的活动价
export const getBargainGoodsActivityprices = id => {
  return axios1.get(`/bargainActivity/bargainActivity/back/product/price?uuid=${id}`)
}
// 获取优惠卷信息
export const getCoupons = (params) => {
  return axios1.get('/content/coupon/official/mall/list', { params })
}
// 获取电商商品分类
export const getCategories = (params) => {
  return axios1.get('/content/product/official/mall/category/list', { params })
}
/**
 * 获取优惠券信息
 * @param {object} params 需要传入的页面信息
 * @return {Promise}
 */
export const getCouponMsgList = (params) => {
  return axios1.get('/activity/signInCoupon/getCouponList', { params })
}
/**
 * 签到奖励-已配置优惠券列表
 * @param {object} params 需要传入的页面信息
 * @return {Promise}
 */
export const getConfigList = (data) => {
  return axios1.postByJson('/activity/signInCoupon/getConfigList', data)
}
/**
 * 签到奖励-保存优惠券列表
 * @param {Array} data 需要保存的优惠券列表
 * @return {Promise}
 */
export const saveCouponInfo = (data) => {
  return axios1.postByJson('/activity/signInCoupon/saveCouponInfo', data)
}
/**
 * 签到奖励-删除已配置内容
 * @param {Number} id 签到奖励-删除已配置内容
 * @return {Promise}
 */
export const delCouponInfo = (id) => {
  return axios1.get(`/activity/signInCoupon/delRewardInfo/${id}`)
}

/**
 * 签到文案-已配置列表
 * @param {object} params 需要传入的页面信息
 * @return {Promise}
 */
export const getSignWriteList = (params) => {
  return axios1.get('/activity/signInCoupon/queryRemarksList', { params })
}

/**
 * 创建签到文案
 * @param {Array} params 需要保存的签到文案
 * @return {Promise}
 */
export const saveSignWriteInfo = (params) => {
  return axios1.get('/activity/signInCoupon/saveRemark', { params })
}

/**
 * 签到文案-删除已配置文案内容
 * @param {Number} id 签到文案-删除已配置内容
 * @return {Promise}
 */
export const delSignInfo = (id) => {
  return axios1.get(`/activity/signInCoupon/delRemark/${id}`)
}
/**
 * 签到奖励获取影视卷
 * @param {object} params 签到奖励获取影视卷
 * @return {Promise}
 */
export const getMOvicSignInfo = () => {
  return axios1.postByJson('/member/recharge/coupon/listValidDistributeCouponId')
}
/**
 * 保存签到奖励
 * @param {object} data
 * @return {Promise}
 */
export const getSaveAwardInfo = (data) => {
  return axios1.postByJson('/activity/signInCoupon/saveRewardInfo', data)
}
// 邀请好友页优惠券下拉列表数据
export const getCouponsList = data => {
  const url = '/content/coupon/official/mall/list?currentPage=1&pageSize=999&needExpired=0'
  return axios1.get(url, data)
}

// 邀请好友注册活动配置详情
export const getInviteConfigDetail = data => {
  /* /invite/back/detail */
  const url = '/activity/invite/back/detail'
  return axios1.get(url, data)
}

/**
* @description:
* @param {Long} id // 有id值说明数据库中已经有配置信息，反之没有
* @param {String} activityTitle // 邀请活动名称
* @param {String} banner // banner图片路径
* @param {String} activityRule // 邀请页规则文案
* @param {String} receiveRule // 被邀请页规则文案
* @param {String} couponId // 邀请好友优惠券id
* @param {String} shareTitle // 分享标题
* @param {String} shareImage // 分享图片路径
* @param {String} couponAmount // 当前选中优惠券的金额
* @return: {Promise}
*/
export const saveActiveConfigDetail = data => {
  const url = '/activity/invite/back/saveOrUpdate'
  return axios1.postByJson(url, data)
}

// 获取问卷调查列表
export const getQuestionnaireList = data => {
  return axios1.postByJson('/activity/questionnaire/back/find/list', data)
}

// 删除问卷调查
export const deleQuestionnaire = questionnaireNo => {
  return axios1.get('/activity/questionnaire/back/delete', {
    params: { questionnaireNo }
  })
}

// 创建或修改问卷(问卷编码为空则新增,否则修改)
export const saveOrUpdateQuestionnaireList = data => {
  return axios1.postByJson('/activity/questionnaire/back/saveOrUpdate', data)
}

// 查询单个问卷接口
export const findOneQuestionnaire = questionnaireNo => {
  return axios1.get('/activity/questionnaire/back/find/one', {
    params: { questionnaireNo }
  })
}

// 导出问卷
export const exportQuestionnaire = questionnaireNo => {
  return axios1({
    method: 'get',
    url: '/activity/questionnaire/back/exportCommitRecord',
    params: {
      questionnaireNo: questionnaireNo
    },
    responseType: 'arraybuffer'
  })
}

// 处理问卷状态
export const pubListQuestionnaire = params => {
  return axios1.get('/activity/questionnaire/back/publist', { params })
}

/**
 *  -- 问卷2.0 --
 *  问卷配置管理
 *  问题配置管理
 */

// 问卷配置管理 - 2.0
// 查看问卷配置列表 - 2.0
export const getQuestionnaireListNext = data => {
  return axios1.postByJson('/activity/questionnaire/config/back/getList', data)
}

// 删除问卷配置【逻辑删除】 - 2.0
export const deleQuestionnaireNext = data => {
  return axios1.delete(`/activity/questionnaire/config/back/delete?id=${data}`)
}

// 新增或修改问卷配置 - 2.0
export const saveOrUpdateQuestionnaireListNext = data => {
  return axios1.postByJson('/activity/questionnaire/config/back/saveOrUpdate', data)
}

// 删除问题配置【逻辑删除】- 2.0
export const deleQuestionnaireAnswerNext = id => {
  return axios1.delete(`/activity/question/config/back/delete?id=${id}`)
}

// 查看可跳题目序号
export const getSkipListNext = id => {
  return axios1.get(`/activity/question/config/back/getSkipList?id=${id}`)
}

// 设置无条件跳题
export const unconditionalSkipNext = data => {
  return axios1.postByJson('/activity/question/config/back/unconditionalSkip', data)
}

// 设置按选项跳题
export const optionSkipNext = data => {
  return axios1.postByJson('/activity/option/config/back/optionSkip', data)
}

// 取消按选项跳题（批量） - 2.0
export const cancelOptionSkipNext = data => {
  return axios1.postByJson(`/activity/option/config/back/cancelOptionSkip?id=${data}`)
}

// 新增或修改问题配置（批量操作选项）
export const saveOrUpdateQuestionnaireAnswerNext = data => {
  return axios1.postByJson('/activity/question/config/back/saveOrUpdate', data)
}

// 查看问卷统计报告 - 2.0
export const getQuestionnaireStatisticsNext = id => {
  return axios1.get(`/activity/questionnaire/config/back/statisticsReport/${id}`)
}

// 查看选项填空列表
export const getFillBlankListNext = data => {
  return axios1.postByJson('/activity/option/config/back/getFillBlankList', data)
}

// 查看填空题填空列表
export const getFillBlankListCompletionNext = data => {
  return axios1.postByJson('/activity/question/config/back/getFillBlankList', data)
}

// 查看文件题文件列表
export const getFillBlankListFileNext = data => {
  return axios1.postByJson('/activity/question/config/back/getFileList', data)
}

// 查看问卷配置详情
export const getNewDetailQuestionnaire = id => {
  return axios1.get(`/activity/questionnaire/config/back/detail/${id}`)
}

// 导出单个问卷表格 - 2.0
export const exportQuestionnaireStatisticsReportNext = id => {
  return axios1({
    method: 'get',
    url: `/activity/questionnaire/config/back/exportExcel/${id}`,
    params: {
      id: id
    },
    responseType: 'arraybuffer'
  })
}

// 文件题下载全部附件 - 2.0
export const downloadQuestionnaireAllFileNext = id => {
  return axios1({
    method: 'get',
    url: '/activity/question/config/back/downloadAllFile',
    params: {
      id: id
    },
    responseType: 'arraybuffer'
  })
}

// 导出单个问卷表格 - 2.0
export const exportQuestionnaireStaListNext = id => {
  return axios1({
    method: 'get',
    url: '/questionnaire/config/back/test',
    params: {
      id: id
    },
    responseType: 'arraybuffer'
  })
}

// 更新问卷状态（0：草稿 1：已上线 2：已下线） - 2.0
export const pubListQuestionnaireNext = data => {
  return axios1.postByJson('/activity/questionnaire/config/back/updateOnlineStatus', data)
}

// 复制问卷配置 - 2.0
export const copyQuestionnaireNext = data => {
  return axios1.postByJson(`/activity/questionnaire/config/back/copy?id=${data}`)
}

// 问题配置管理 - 2.0
// 批量修改问题顺序（跳题关系置空） - 2.0
export const questionnairBatchUpdateSequenceNext = data => {
  return axios1.postByJson('/activity/question/config/back/batchUpdateSequence', data)
}

// 批量查看问题及选项配置列表 - 2.0
export const getQuestionOptionListNext = id => {
  return axios1.get(`/activity/question/config/back/getQuestionOptionList/${id}?questionnaireConfigId=${id}`)
}

/*
灵犀系列赠品领取活动（赠品活动）
*/
// 赠品政策后台列表
export const getGiftPolicyList = data => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/shopActivityConfig/giftYun/list', null, config)
}

// 删除运营政策
export const delGiftPolicy = id => {
  return axios1.get(`/activity/shopActivityConfig/delById?id=${id}`)
}

// 政策后台配置
export const saveOrUpdateAppGift = data => {
  return axios1.postByJson('/activity/shopActivityConfig/saveOrUpdateAppGift', data)
}

// 运营人员查看配置政策
export const getGiftPolicyDetailById = id => {
  return axios1.get(`/activity/shopActivityConfig/findByYun?id=${id}`)
}

// 查找未创建政策的月份
export const getGiftPolicyMonthByYear = data => {
  return axios1.get(`/activity/shopActivityConfig/findByYun/month?monthTime=${data.monthTime}&id=${data.id}`)
}

// （赠品领取记录）赠品列表
export const giftReList = data => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/giftRe/list', {}, config)
}
// 后台未领取过期（重新发放）
export const giftReissue = data => {
  return axios1.post('/activity/giftRe/issue', data)
}
// （赠品领取记录）通过/拒绝
export const isAdopt = data => {
  return axios1.post('/activity/giftRe/operation', data)
}

/**
 * @description: 后台物流信息展示
 * @param {*}
 * @return {*}
 */
export const giftLogisticsInformation = data => {
  return axios1.postByJson('/activity/shopNc/backstageInfo', data)
}

// 赠品库管理（赠品列表）
export const getGoodsList = data => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/shopGift/getGoodsList', null, config)
}
// 赠品库管理（编辑）
export const getGoodsById = id => {
  return axios1.get(`/activity/shopGift/getGoodsById/${id}`)
}
// 赠品库管理（删除）
export const delGoods = id => {
  return axios1.get(`/activity/shopGift/delGoods/${id}`)
}
// 赠品库管理（新建&编辑）
export const saveGoods = data => {
  return axios1.postByJson('/activity/shopGift/saveGoods', data)
}
// 赠品规则管理（获取列表）
export const getRulesList = data => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('activity/shopGift/getRulesList', null, config)
}
// 赠品规则管理（删除赠品规则）
export const delRule = id => {
  return axios1.get(`/activity/shopGift/delRule/${id}`)
}

// 根据id获取赠品规则详情信息
export const findRuleById = id => {
  return axios1.get(`/activity/shopGift/findRuleById/${id}`)
}

// 获取产品型号列表
export const getProductList = () => {
  return axios1.get('/activity/shopGift/getProductList')
}

// 获取产品赠品列表
export const getGiftList = () => {
  return axios1.get('/activity/shopGift/getGiftList')
}

// 获取sku产品列表
export const getSkuProduct = data => {
  return axios1.postByJson('/activity/shopCrm/skuInfo', data)
}

// 上传的文件提前检查接口
// 点击文件上传时调用此接口检查文件是否符合规范
export const checkUplodaFile = data => {
  return axios1({
    method: 'POST',
    url: '/activity/shopGift/checkUplodaFile',
    processData: false,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 上传固定名单文件（保存完成后立马调用）
export const saveRuleFile = data => {
  return axios1({
    method: 'POST',
    url: '/activity/shopGift/saveRuleFile',
    processData: false,
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 新增的直发手机号赠品发放（上传固定名单文件完成后立马调用）
export const saveGiftPhones = data => {
  return axios1.postByJson('/activity/shopGift/savePhones', data)
}

// 新增或修改规则
export const saveRule = data => {
  return axios1.postByJson('/activity/shopGift/saveRule', data)
}

// 赠品活动兑换码列表
export const getExchangecodeList = data => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/activity/giftcode/exchangecode/list', {}, config)
}

/*
*会员服务（快捷入口）
*/
// 会员服务配置接口
// export const backList = () => {
//   return axios1.get('/member/after/sale/configure/backList')
// }
export const backList = (data, params) => {
  return axios1.postByJson('/member/after/sale/configure/backList', data, { params })
}
// 保存
export const membersaveOrUpdate = data => {
  return axios1.postByJson('/member/after/sale/saveOrUpdate', data)
}

// 编辑
export const membedetail = id => {
  const config = {
    params: {
      id: id
    }
  }
  return axios1.post('/member/after/sale/detail', null, config)
}
// 会员服务更新位置
export const refreshPosition = data => {
  return axios1.postByJson('/member/after/sale/refreshPosition', data)
}

// 删除
export const memberdelete = id => {
  const config = {
    params: {
      id: id
    }
  }
  return axios1.post('/member/after/sale/delete', null, config)
}

// 上下架
export const exupdateStatus = params => {
  // const config = {
  //   params: {
  //     id: par.id,
  //     status: par.status
  //   }
  // }
  return axios1.post('/member/after/sale/updateStatus', null, { params })
}

/*
LPL春季赛活动
*/
// 累计拉新领奖品
// 查看邀请好友活动奖品配置列表
export const getInvitetList = data => {
  return axios1.postByJson('/bargainActivity/invite/prize/back/getList', data)
}

// 批量删除邀请好友活动奖品配置【逻辑删除)
export const deleAward = data => {
  return axios1.postByJson('/bargainActivity/invite/prize/back/delete', data)
}

// 新增或修改邀请好友活动奖品配置
export const saveOrUpdateAward = data => {
  return axios1.postByJson('/bargainActivity/invite/prize/back/saveOrUpdate', data)
}

// 查看邀请好友活动奖品配置详情
export const awardDetail = id => {
  return axios1.get(`/bargainActivity/invite/prize/back/detail/${id}`)
}

// 电商商品配置
// 查看电商活动商品配置列表
export const getCommodityList = data => {
  return axios1.postByJson('/bargainActivity/ecommerce/commodity/back/getList', data)
}

// 批量删除电商活动商品配置【逻辑删除】
export const deleCommodity = data => {
  return axios1.postByJson('/bargainActivity/ecommerce/commodity/back/delete', data)
}

// 新增或修改电商活动商品配置
export const saveOrUpdateCommodity = data => {
  return axios1.postByJson('/bargainActivity/ecommerce/commodity/back/saveOrUpdate', data)
}

// 查看电商活动商品配置详情
export const commodityDetail = id => {
  return axios1.get(`/bargainActivity/ecommerce/commodity/back/detail/${id}`)
}

// 查看竞猜活动规则配置详情
export const activityRuleDetail = () => {
  return axios1.get('/bargainActivity/guess/ruleConfig/back/detail/1')
}

// 新增或修改竞猜活动规则配置
export const saveOrUpdateActivityRule = data => {
  return axios1.postByJson('/bargainActivity/guess/ruleConfig/back/saveOrUpdate', data)
}

/**
 * 竞猜活动配置管理
 */
// 查看竞猜活动配置详情
export const getQuizMgtDetail = () => {
  return axios1.get('/bargainActivity/guess/config/back/detail/1')
}

// 新增或修改竞猜活动配置
export const saveOrUpdateQuizMgt = data => {
  return axios1.postByJson('/bargainActivity/guess/config/back/saveOrUpdate', data)
}

// 竞猜活动问题选项结算
export const toSummarizeQuiz = data => {
  return axios1.postByJson('/bargainActivity/guess/config/back/option/summarize', data)
}

/**
 * 竞猜活动任务配置管理
 */
// 查看竞猜活动任务配置列表
export const getQuizTaskList = data => {
  return axios1.postByJson('/bargainActivity/guess/task/back/getList', data)
}

// 批量删除竞猜活动任务配置【逻辑删除】
export const deleQuizTask = data => {
  return axios1.postByJson('/bargainActivity/guess/task/back/delete', data)
}

// 新增或修改竞猜活动任务配置
export const saveOrUpdateQuizTask = data => {
  return axios1.postByJson('/bargainActivity/guess/task/back/saveOrUpdate', data)
}
// 查看竞猜活动任务配置详情
export const quizTaskDetail = id => {
  return axios1.get(`/bargainActivity/guess/task/back/detail/${id}`)
}

/**
 * 竞猜活动奖品配置管理
 */
// 查看竞猜活动奖品配置列表
export const getQuizAwardList = data => {
  return axios1.postByJson('/bargainActivity/guess/prize/back/getList', data)
}

// 批量删除竞猜活动奖品配置【逻辑删除】
export const deleQuizAward = data => {
  return axios1.postByJson('/bargainActivity/guess/prize/back/delete', data)
}

// 新增或修改竞猜活动奖品配置
export const saveOrUpdateQuizAward = data => {
  return axios1.postByJson('/bargainActivity/guess/prize/back/saveOrUpdate', data)
}

// 查看竞猜活动奖品配置详情
export const quizAwardDetail = id => {
  return axios1.get(`/bargainActivity/guess/prize/back/detail/${id}`)
}

// 春决赛活动中奖记录高级筛选(包含竞猜活动 、 邀请好友活动 、 天天抽奖活动中奖记录)
export const getQuizRecording = data => {
  return axios1.postByJson('/bargainActivity/guess/prize/back/getAllRecord', data)
}

// 发放用户奖品领取记录--拉新
export const getLPLAwardRecording = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/bargainActivity/invite/prize/back/record/issue', null, config)
}

// 发放用户奖品领取记录--竞猜
export const getLPLQuizRecording = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/bargainActivity/guess/prize/back/record/issue', null, config)
}

/**
 * 618主会场后台
 */
// 活动规则(复用竞猜活动规则接口)
// 查看活动日历配置列表
export const getActivityCalendarList = data => {
  return axios1.postByJson('/bargainActivity/activity/calendar/back/getList', data)
}

// 批量删除活动日历配置【逻辑删除】
export const deleActivityCalendar = data => {
  return axios1.postByJson('/bargainActivity/activity/calendar/back/delete', data)
}

// 查看活动日历配置详情
export const activityCalendarDetails = id => {
  return axios1.get(`/bargainActivity/activity/calendar/back/detail/${id}`)
}

// 新增或修改活动日历配置
export const saveOrUpdateActivityCalendar = data => {
  return axios1.postByJson('/bargainActivity/activity/calendar/back/saveOrUpdate', data)
}

/**
 * 618电商专区
 */
// 查看电商专区配置列表
export const getElectricityConfigList = data => {
  return axios1.postByJson('/bargainActivity/commodity/specialArea/back/getList', data)
}

// 删除电商专区配置【逻辑删除】
export const deleMainVenueElectricity = id => {
  return axios1.postByJson(`/bargainActivity/commodity/specialArea/back/delete?id=${id}`)
}

// 查看电商专区配置详情
export const MainVenueElectricityDetails = id => {
  return axios1.get(`/bargainActivity/commodity/specialArea/back/detail/${id}`)
}

// 新增或修改电商专区配置
export const saveOrUpdateMainVenueElectricity = data => {
  return axios1.postByJson('/bargainActivity/commodity/specialArea/back/saveOrUpdate', data)
}

// 电商专区品类配置
// 查看商品品类配置列表
export const getMainVenueCategoryList = data => {
  return axios1.postByJson('/bargainActivity/commodity/category/back/getList', data)
}

// 删除商品品类配置【逻辑删除】
export const deleMainVenueCategory = id => {
  return axios1.postByJson(`/bargainActivity/commodity/category/back/delete?id=${id}`)
}

// 查看商品品类配置详情
export const MainVenueCategoryDetails = id => {
  return axios1.get(`/bargainActivity/commodity/category/back/detail/${id}`)
}

// 新增或修改商品品类配置
export const saveOrUpdateMainVenueCategory = data => {
  return axios1.postByJson('/bargainActivity/commodity/category/back/saveOrUpdate', data)
}

// 电商专区商品配置
// 查看活动商品配置列表
export const getMainVenueGoodsList = data => {
  return axios1.postByJson('/bargainActivity/activity/commodity/back/getList', data)
}

// 删除活动商品配置【逻辑删除】
export const deleMainVenueGoods = id => {
  return axios1.postByJson(`/bargainActivity/activity/commodity/back/delete?id=${id}`)
}

// 查看活动商品配置详情
export const MainVenueGoodsDetails = id => {
  return axios1.get(`/bargainActivity/activity/commodity/back/detail/${id}`)
}

// 新增或修改活动商品配置
export const saveOrUpdateMainVenueGoods = data => {
  return axios1.postByJson('/bargainActivity/activity/commodity/back/saveOrUpdate', data)
}

// 618活动(优惠券活动配置管理)

// 删除优惠券活动配置
export const deleteIssue = (id) => {
  const config = {
    params: {
      id
    }
  }
  return axios1.post('/bargainActivity/coupon/activity/back/delete', null, config)
}

// 查看优惠券活动配置详情
export const detailEcoupon = id => {
  return axios1.get(`/bargainActivity/coupon/activity/back/detail/${id}`)
}

// 查看优惠券活动配置列表
export const getAllRecord = data => {
  return axios1.postByJson('/bargainActivity/coupon/activity/back/getList', data)
}

// 新增或修改优惠券活动配置
export const savEcouponOrUpdate = data => {
  return axios1.postByJson('/bargainActivity/coupon/activity/back/saveOrUpdate', data)
}

/* 短链制作 */
// 保存 /shortChain/saveOrUpdate
export const saveOrUpdateMSM = data => {
  return axios1.postByJson('/activity/shortChain/saveOrUpdate', data)
}

// 获取列表
export const findListMSM = params => {
  return axios1.get('/activity/shortChain/findList', { params })
}

// 删除
export const deleteMSM = (id) => {
  const config = {
    params: {
      id
    }
  }
  return axios1.post('/activity/shortChain/delete', null, config)
}

// 查看详情
export const detailMSM = (id) => {
  const config = {
    params: {
      id
    }
  }
  return axios1.post('/activity/shortChain/detail', null, config)
}

// 717奥运会活动---查看邀请好友活动奖品配置列表
export const getOlympicInvitetList = data => {
  return axios1.postByJson('/bargainActivity/invite/prize/config/back/getList', data)
}

// 717奥运会活动 --- 删除邀请好友活动奖品配置
export const deleOlympicAward = data => {
  return axios1.post('/bargainActivity/invite/prize/config/back/delete', data)
}

// 717奥运会活动----查看邀请好友活动奖品配置详情
export const awardOlympicDetail = id => {
  return axios1.get(`/bargainActivity/invite/prize/config/back/detail/${id}`)
}

// 717奥运会活动----新增或修改邀请好友活动奖品配置
export const saveOrUpdateOlympicAward = data => {
  return axios1.postByJson('/bargainActivity/invite/prize/config/back/saveOrUpdate', data)
}

// 717奥运会活动----查看竞猜活动规则配置详情
export const activityRuleOlympicDetail = (id) => {
  return axios1.get(`/bargainActivity/activity/ruleConfig/back/detail/${id}`)
}

// 717奥运会活动----新增或修改竞猜活动规则配置
export const saveOrUpdateOlympicActivityRule = data => {
  return axios1.postByJson('/bargainActivity/activity/ruleConfig/back/saveOrUpdate', data)
}

// 717奥运会活动----邀请好友活动中奖记录高级筛选
export const getQuizOlympicRecording = data => {
  return axios1.postByJson('/bargainActivity/inviteActivity/prize/back/getAllRecord', data)
}

// 717奥运会活动 --- 发放用户奖品领取记录
export const getOlympicQuizRecording = (data) => {
  const config = {
    params: {
      ...data
    }
  }
  return axios1.post('/bargainActivity/inviteActivity/prize/back/record/issue', null, config)
}

// 717奥运会活动---- 邀请好友活动中奖记录导出
export const exportOlympicAllRecord = params => {
  return axios1({
    method: 'get',
    url: '/bargainActivity/inviteActivity/prize/back/allRecord/export',
    params,
    responseType: 'arraybuffer'
  })
}

// 精彩活动列表---获取会员活动说明
export const getActivityExplain = () => {
  return axios1.get('/activity/activity/explain/getActivityExplain')
}

// 精彩活动列表---获取会员活动说明
export const updateActivityExplain = (params) => {
  return axios1.post('/activity/activity/explain/updateActivityExplain', null, { params })
}

// 会员快捷服务---获取服务运营说明
export const getServiceExplain = () => {
  return axios1.get('/activity/activity/explain/getServiceExplain')
}

// 会员快捷服务---更新会员活动说明
export const updateServiceExplain = (params) => {
  return axios1.post('/activity/activity/explain/updateServiceExplain', null, { params })
}

// 精彩活动列表----更新列表排序
export const refreshActivitySort = (params) => {
  return axios1.post('/activity/activity/back/refreshSort', null, { params })
}
// 会员快捷服务---添加分类模块
export const saveServiceType = (data) => {
  return axios1.postByJson('/member/member/sector/saveOrUpdate', data)
}
// 会员快捷服务---获取分类板块
export const getTypeExplainList = () => {
  return axios1.get('/member/member/sector/configure/backList')
}
// 会员快捷服务---删除分类模块
export const deleteServiceType = (params) => {
  return axios1.postByJson('/member/member/sector/delete', null, { params })
}
// 会员快捷服务---编辑分类模块
export const editServiceType = (params) => {
  return axios1.postByJson('/member/member/sector/detail', null, { params })
}
// 会员快捷服务---分类更新分类位置模块
export const positionServiceType = (data) => {
  return axios1.postByJson('/member/member/sector/refreshPosition', data)
}
// 秋发活动----查看竞猜活动规则配置详情
export const activityProductRuleDetail = () => {
  return axios1.get('/bargainActivity/activity/ruleConfig/back/detail/4')
}
// 秋发活动-----新增或修改竞猜活动规则配置
export const saveOrUpdateProductActivityRule = data => {
  return axios1.postByJson('/bargainActivity/activity/ruleConfig/back/saveOrUpdate', data)
}
// 双11----查看所有活动的详情
export const getActivityDetail = (data) => {
  return axios1.postByJson('/bargainActivity/activity/config/back/getList', { data })
}

// 新品试用------查询活动列表
export const getNewProductList = (params, data) => {
  return axios1.postByJson('/activity/pt/front/listPt', data, { params })
}
// 新品试用-----查看新品试用配置详情
export const getNewProductDetail = (id) => {
  return axios1.get(`/activity/pt/front/detail/${id}`)
}
// 新品试用------新建产品试用配置
export const addNewProductTry = (data) => {
  return axios1.postByJson('/activity/pt/front/createPtConfig', data)
}
// 新品试用------编辑产品试用配置
export const editNewProductTry = (data) => {
  return axios1.postByJson('/activity/pt/front/updatePtConfig', data)
}
// 新品试用------删除产品试用配置
export const delNewProductTry = (data) => {
  return axios1.postByJson('/activity/pt/front/deleteActivity', data)
}
// 新品试用-------查看新品试用规则配置详情
export const getProductTrialRule = () => {
  return axios1.get('/activity/pt/front/productTrialRule')
}
// 新品试用-------查看新品试用规则配置详情
export const saveProductTrialRule = (data) => {
  return axios1.postByJson('/activity/pt/front/productTrialRule', data)
}
// 新品试用-------导出单个新品试用问卷表格
export const exportExeclProduct = (id) => {
  return axios1({
    method: 'GET',
    url: `/activity/pt/front/exportExcel/${id}`,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取产品品类列表
export const getCategoryList = () => {
  return axios1.get('/activity/shopGift/categorys')
}

// 根据品类获取产品型号列表
export const getProductListBycategory = (categoryCodeArr) => {
  return axios1.postByJson('/activity/shopGift/products/all', categoryCodeArr)
}

// 查询绑定记录
export const getBindRecord = (params) => {
  return axios1.get('/activity/shopGift/deviceBind/record', { params })
}
